import { createAction } from "@reduxjs/toolkit";
import { Pageable } from "../../services/pageable";
import { FetchableError, FetchableSuccess } from "../common/fetchable/helpers";
import { ChainDTO } from "./models/dto";

export namespace ChainActions {
  export enum ActionTypes {
    getAllWalletReports = "Chain: Get All Individual WalletReports",
    setAllWalletReports = "Chain: Set All Individual WalletReports",
    resetAllWalletReports = "Chain: Reset All Individual WalletReports",
    getSingleWalletReports = "Chain: Get Single Individual WalletReports",
    setSingleWalletReports = "Chain: Set Single Individual WalletReports",
    setAllWalletReportsPagination = "Chain: Set All Individual WalletReports Pagination",
  }

  //------------------------ WalletReports
  export const resetAllWalletReports = createAction(
    ActionTypes.resetAllWalletReports
  );

  export const getAllWalletReports = createAction(
    ActionTypes.getAllWalletReports
  );

  export const setAllWalletReports = createAction<
    FetchableSuccess<ChainDTO.Responses.GetAllWalletReports.T> | FetchableError,
    ActionTypes.setAllWalletReports
  >(ActionTypes.setAllWalletReports);

  export const setAllWalletReportsPagination = createAction<
    Pageable.T<
      Exclude<keyof ChainDTO.Responses.GetSingleWalletReports.T, "riskProfile">
    >,
    ActionTypes.setAllWalletReportsPagination
  >(ActionTypes.setAllWalletReportsPagination);

  export const getSingleWalletReports = createAction<
    ChainDTO.Responses.GetSingleWalletReports.T["id"],
    ActionTypes.getSingleWalletReports
  >(ActionTypes.getSingleWalletReports);

  export const setSingleWalletReports = createAction<
    { id: string; result: ChainDTO.Responses.GetSingleWalletReports.T },
    ActionTypes.setSingleWalletReports
  >(ActionTypes.setSingleWalletReports);

  export type GetAllWalletReports = ReturnType<typeof getAllWalletReports>;
  export type SetAllWalletReports = ReturnType<typeof setAllWalletReports>;
  export type GetSingleWalletReports = ReturnType<
    typeof getSingleWalletReports
  >;
  export type SetSingleWalletReports = ReturnType<
    typeof setSingleWalletReports
  >;
  export type ResetAllWalletReports = ReturnType<typeof resetAllWalletReports>;
  export type SetAllWalletReportsPagination = ReturnType<
    typeof setAllWalletReportsPagination
  >;

  export type Actions =
    // ---
    | GetAllWalletReports
    | SetAllWalletReports
    | GetSingleWalletReports
    | SetSingleWalletReports
    | ResetAllWalletReports
    | SetAllWalletReportsPagination;
}
